import { createReducer, on } from '@ngrx/store';
import * as SalesforceActions from './salesforce.actions';

export const salesforceFeatureKey = 'salesforce';

export interface SalesforceState {
  objects: any;
  loading: boolean;
  error: {
    timestamp?: number;
    key?: string;
    error?: unknown;
  };
}

export const initialState: SalesforceState = {
  objects: null,
  loading: false,
  error: {}
};

export const reducer = createReducer(
  initialState,
  on(SalesforceActions.SalesforceLoginAndGetSelectedObjects, (state) => ({
    ...state,
    loading: true
  })),
  on(SalesforceActions.SalesforceLoginAndGetSelectedObjectsSuccessful, (state, action) => ({
    ...state,
    objects: action.payload.selectedObjects,
    selectedObjects: action.payload.selectedObjects,
    user: {
      username: action.payload.username,
      password: action.payload.password,
      token: action.payload.token
    }
  })),
  on(SalesforceActions.SalesforceLoginAndGetSelectedObjectsFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload.error
  })),
  on(SalesforceActions.SalesforceLoginAndGetObjectsSuccessful, (state, action) => ({
    ...state,
    objects: action.payload.objects,
    loading: false
  })),
  on(SalesforceActions.SalesforceLoginAndGetObjectsFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload.error
  })),
  on(SalesforceActions.CreateSalesforceObjectSuccessful, (state, action) => ({
    ...state
  })),
  on(SalesforceActions.SalesforceSelectedObjectsUpdate, (state, action) => ({
    ...state,
    selectedObjects: action.payload.selectedObjects,
    loading: false
  })),
  on(SalesforceActions.ResetSalesforce, () => initialState)
);
